// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TemplateEditor_top__GLBQq {
  z-index: 4;
  position: relative;
}

.TemplateEditor_title__P-XZa {
  width: 100%;
}

.TemplateEditor_contentModal__p4w8t {
  height: calc(100vh - 5em) !important;
}

.TemplateEditor_docPreviewContainer__kKTbb {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/TemplateEditor/TemplateEditor.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AACA;EACE,oCAAA;AAEF;;AAAA;EACE,WAAA;AAGF","sourcesContent":[".top {\n  z-index: 4;\n  position: relative;\n}\n\n.title {\n  width: 100%;\n}\n.contentModal {\n  height: calc(100vh - 5em) !important;\n}\n.docPreviewContainer {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"top": `TemplateEditor_top__GLBQq`,
	"title": `TemplateEditor_title__P-XZa`,
	"contentModal": `TemplateEditor_contentModal__p4w8t`,
	"docPreviewContainer": `TemplateEditor_docPreviewContainer__kKTbb`
};
export default ___CSS_LOADER_EXPORT___;
